import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { checkInitialLoginForExistingCookie } from 'routes/AppContainer/actions';
import { useUrlSearchParams } from 'utils/customHooks/useUrlSearchParams';
import { useSelectorJs } from 'utils/customHooks';
import { selectCurrentOrgId } from 'global/accessToken/selectors';
import { LoaderWithoutSuir } from 'components/Loader/LoaderWithoutSuir';
import AltaLoginApp from '../../../altaLoginApp/components/App';

/**
 * Temporary component allowing for leaning into previously existing sagas
 * for determining where to route user at initial login.
 */
const LoginPage = () => {
  const { redirectUrl } = useUrlSearchParams();
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);
  /**
   * Until we fully transition away from the legacy login flow, we need to
   * check the current org ID, as it forces a rerender of the component,
   * leading to a secondary call to the `checkInitialLoginForExistingCookie`
   * action. This is necessary because `checkInitialLoginForExistingCookie` behaves
   * differently the second time when an org ID exists. It's honestly lucky that it even
   * worked in the first place...
   */
  const currentOrgId = useSelectorJs(selectCurrentOrgId());

  useEffect(() => {
    dispatch(checkInitialLoginForExistingCookie(redirectUrl));

    // If forever reason this is taking too long to load, we can show the login page
    const timeout = setTimeout(() => {
      setShowLogin(true);
    }, 6000);

    return () => {
      clearTimeout(timeout);
    };
  }, [redirectUrl, dispatch, currentOrgId]);

  return showLogin ? <AltaLoginApp /> : <LoaderWithoutSuir />;
};

export default LoginPage;
